'use es6';

import { List, Record } from 'immutable';
import { QuizTypes } from '../constants/QuizConstants';
export default Record({
  assetId: null,
  classId: null,
  completed: null,
  description: null,
  displayOrder: null,
  id: null,
  mostRecentAttempt: null,
  name: null,
  questions: List(),
  language: null,
  passThreshold: null,
  quizLength: null,
  quizType: QuizTypes.INDIVIDUAL_VALIDATION
}, 'Quiz');